import React from 'react';

import { FooterWrapper } from './styles';

import logo from '../../assets/logo.png';

import { FaFacebookF, FaPhone, FaEnvelope, FaMapMarkerAlt, FaTwitter, FaInstagram } from 'react-icons/fa';

function Footer() {
    return (
        <FooterWrapper>
            <div>
                <a href="/">
                    <img src={logo} alt="" />
                </a>
                <ul>
                    <li>
                        <FaPhone className="icon"/>
                        <p>356-461-233-235</p>
                    </li>
                    <li>
                        <FaEnvelope className="icon"/>
                        <p>bridge@gmail.com</p>
                    </li>
                    <li>
                        <FaMapMarkerAlt />
                        <p> Street Victoria 800</p>
                    </li>
                </ul>
            </div>
            <div>
                <a href="/">
                    <FaFacebookF />
                </a>
                <a href="/">
                    <FaTwitter />
                </a>
                <a href="/">
                    <FaInstagram />
                </a>
            </div>
        </FooterWrapper>
    )
}

export default Footer;